import * as React from 'react';
import { useState } from 'react';
import { useRecordContext, useNotify, Confirm } from 'react-admin';
import { Chip, Box, FormControl, Stack, Button } from '@mui/material';
import { dataProvider } from '../../../DataProvider';
import MAutoComplete from '../../../components/controls/MAutoComplete';

interface IData {
    [key: string]: any;
}

const EditableStatusField: React.FC<IData> = ({ source, tags, reload }) => {
    const record = useRecordContext();
    const [isEditing, setIsEditing] = useState(false);
    const [isConfirmOpen, setConfirmOpen] = useState(false);
    const [newTags, setNewTags] = useState('');
    const notify = useNotify();

    if (!record) return null;

    const handleClick = (event) => {
        event.stopPropagation(); // Prevent the row click event
        setIsEditing(true);
    };

    const handleClose = (event) => {
        event.stopPropagation();
        setIsEditing(false);
    };

    // NEW: Handler for the chip's delete icon
    const handleDelete = (_, deleteTag) => {
        // setNewTags(removeTags(record[source], deleteTag));
        setNewTags(deleteTag);
        setConfirmOpen(true);
    };
    // Cancel delete Tag => just close the dialog.
    const handleCloseConfirm = (event) => {
        event.stopPropagation();
        setConfirmOpen(false);
    };

    // confirms delete Tag => perform the update and close the dialog.
    const handleConfirmDelete = () => {
        updateTags('remove');
    };

    const handleSelection = (props) => {
        props && setNewTags(props.join(','));
    };

    const handleSave = (event) => {
        event.stopPropagation();
        updateTags('add');
        setIsEditing(false);
    };

    const updateTags = (mode) => {
        setConfirmOpen(false);
        let updateData = [
            {
                sm_event_id: record['id'],
                sm_tags: newTags,
                remove_tags: mode === 'remove',
                sm_old_tags: record[source]
            }
        ];
        dataProvider.postData('SmEventCheck', 'UpdateTags', updateData)
            .then((response: any) => {
                if (response?.data?.length) {
                    notify('Events updated successfully', { type: 'success' });
                } else {
                    notify(`Error: ${response?.body}`, { type: 'error' });
                }
            })
            .catch((error: any) => {
                notify(`Error: ${error.message}`, { type: 'error' });
            })
            .finally(() => {
                reload();
            });
    };
    return isEditing ? (
        <FormControl sx={{ m: 1, width: 200 }}>
            <MAutoComplete choices={tags.filter((tag: any) => !record[source].split(',').filter((x: any) => x).some(x => tag === x))} label={'Tags'} onChange={handleSelection} />
            <Stack sx={{ mt: 2 }} direction="row" spacing={2}>
                <Button onClick={handleSave} variant="contained">Save</Button>
                <Button onClick={handleClose} variant="outlined">Cancel</Button>
            </Stack>
        </FormControl>
    ) : (
        <>
            <Box
                onClick={handleClick}
                sx={{
                    cursor: 'pointer',
                    width: '100%',
                    // Vertically center the chip within the cell's padding
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: '40px', // Đặt chiều cao tối thiểu để ô trống không bị "xẹp"
                }}
            >
                {record[source] && record[source].split(',').filter((x: any) => x).map((tag: any) => <Chip label={tag} size="small" onDelete={(e) => handleDelete(e, tag)} key={tag + record['id']} />)}

            </Box>
            <Confirm
                isOpen={isConfirmOpen}
                title={`Clear ${source}`}
                content="Are you sure you want to clear this value?"
                onConfirm={handleConfirmDelete}
                onClose={handleCloseConfirm}
            />
        </>

    );
};

export default EditableStatusField;